import { TickMarkWithBackgroundIcon } from '@/components/icons/TickMarkWithBackgroundIcon.tsx';

export const MaintenancePage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground">
      <div className="text-center max-w-lg p-8">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          We'll Be Right Back
        </h1>
        <p className="text-muted-foreground mb-8">
          We're performing essential system maintenance to ensure your Viome
          experience remains secure and reliable. Thank you for your patience.
        </p>
        <div className="bg-background-secondary rounded-lg p-6 mb-8">
          <p className="text-muted-foreground">Expected completion time:</p>
          <p className="text-2xl font-bold text-teal-500">5-6 hours</p>
        </div>
        <div className="text-left">
          <ul className="space-y-4">
            <li className="flex items-center text-foreground">
              <TickMarkWithBackgroundIcon className="h-6 w-6 mr-3" />
              System performance optimization
            </li>
            <li className="flex items-center text-foreground">
              <TickMarkWithBackgroundIcon className="h-6 w-6 mr-3" />
              Enhanced security measures
            </li>
            <li className="flex items-center text-foreground">
              <TickMarkWithBackgroundIcon className="h-6 w-6 mr-3" />
              Infrastructure stability improvements
            </li>
          </ul>
        </div>
        <hr className="my-8 border-border" />
        <p className="text-muted-foreground">
          Questions? Contact our support team at{' '}
          <a href="mailto:support@viome.com" className="text-teal-500">
            support@viome.com
          </a>
        </p>
      </div>
    </div>
  );
};
